import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const ChevronUpIconSmall: React.FC<IconProps> = (props) => (
  <IconWrapper size="small" {...props}>
    <path d="m15 11.15-7-7-7 7 .71.7L8 5.56l6.29 6.29.71-.7Z" />
  </IconWrapper>
)

export default ChevronUpIconSmall
